import { useState, useEffect } from "react";
import { io, Socket } from "socket.io-client";
import { WAStatus, WAEvent, WAReadiness } from "../types";

export function useSocket() {
  const [socket, setSocket] = useState<Socket | null>(null);
  const [status, setStatus] = useState<WAStatus | null>(null);
  const [events, setEvents] = useState<WAEvent[]>([]);
  const [readiness, setReadiness] = useState<WAReadiness | null>(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    const s = io();
    setSocket(s);

    s.on("connect", () => setConnected(true));
    s.on("disconnect", () => setConnected(false));
    s.on("wa:status", (data: WAStatus) => setStatus(data));
    s.on("wa:events", (data: WAEvent[]) => {
      setEvents((prev) => [...prev, ...data].slice(-50));
    });
    s.on("wa:readiness", (data: WAReadiness) => setReadiness(data));

    return () => {
      s.disconnect();
    };
  }, []);

  return { socket, status, events, readiness, connected };
}
